// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1WDd9","infoBtn":"quickbooks_infoBtn__N4uHx","formBox":"quickbooks_formBox__24Gyg","formFooter":"quickbooks_formFooter__V2YHu"};